<template>
<div class="page_smart_park">
	<div class="appoint">
		<div class="top">
			<div class="banner" v-if="info">
				<van-image class="thumb" fit="cover" :src="info.thumb ? imageUrl+info.thumb : $publicData.defalutFengmian " :show-error="false" :show-loading="false" />
			</div>
			<!-- 票种 -->
			<div class="ticket">
				<div class="ticket_l">
					<div class="text_wrap" @click="toAppoint(1,0)">
						<span class="name">团体门票</span>
						<span class="desc">参观门票预约</span>
					</div>
				</div>
				<div class="ticket_r">
					<div class="item">
						<div class="text_wrap" @click="toAppoint(0,0)">
							<span class="name">散客门票</span>
							<span class="desc">参观门票预约</span>
						</div>
					</div>
					<div class="item cika">
						<div class="text_wrap" @click="toAppoint(0,1)">
							<span class="name">次卡门票</span>
							<span class="desc">次卡门票预约</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<!-- 信息 -->
		<div class="info" v-if="info">
			<div class="item" v-html="info.content"></div>
		</div>
		<!-- <div class="info">
			<div class="item">
				<div class="name">
					<img :src="publicPath+'statics/images/smartpark/icon_time.png'" alt="" class="icon">
					<span class="">开放时间</span>
				</div>
				<div class="text">每周一闭馆(节假日除外) ，开馆日9:00-16:30 开放，16:00停 止入内。试运行期间只接待预约观众。</div>
			</div>
			<div class="item">
				<div class="name">
					<img :src="publicPath+'statics/images/smartpark/icon_tips2.png'" alt="" class="icon">
					<span class="">预约须知</span>
				</div>
				<div class="text">每周一闭馆(节假日除外) ，开馆日9:00-16:30 开放，16:00停 止入内。试运行期间只接待预约观众。</div>
			</div>
			<div class="item">
				<div class="name">
					<img :src="publicPath+'statics/images/smartpark/icon_tips.png'" alt="" class="icon">
					<span class="">参观须知</span>
				</div>
				<div class="text">每周一闭馆(节假日除外) ，开馆日9:00-16:30 开放，16:00停 止入内。试运行期间只接待预约观众。</div>
			</div>
			<div class="item">
				<div class="name">
					<img :src="publicPath+'statics/images/smartpark/icon_forbidden.png'" alt="" class="icon">
					<span class="">请勿带携带物品清单</span>
				</div>
				<div class="text">每周一闭馆(节假日除外) ，开馆日9:00-16:30 开放，16:00停 止入内。试运行期间只接待预约观众。</div>
			</div>
			<div class="item">
				<div class="name">
					<img :src="publicPath+'statics/images/smartpark/icon_camera.png'" alt="" class="icon camera">
					<span class="">展品拍照须知</span>
				</div>
				<div class="text">每周一闭馆(节假日除外) ，开馆日9:00-16:30 开放，16:00停 止入内。试运行期间只接待预约观众。</div>
			</div>
		</div> -->
		<!-- 来馆交通 -->
		<!-- <div class="info">
			<div class="title">来馆交通</div>
			<div class="mapwrap" id="map"></div>
			<div class="text">景点地址：天津市津南区葛沽镇天津大道葛万公路出口</div>
			<div class="text">开放时间：周二至周日 09:00-16:30，周一 不开放</div>
			<div class="text">公共交通：乘坐629路，在葛沽创意中心站下车，步行450米至终点</div>
		</div> -->
	</div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
			richImageUrl: this.$publicData.richTextImage,
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			venue_id: this.$route.query.venue_id, // 场馆ID
			info: null // 场馆详情
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
		var that = this
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '场馆详情',
					'rightStyle': 'share'
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                    } else {
                        this.token = "";
                    }
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
			//注册方法，右侧点击分享
            this.$bridge.registerhandler('sdjy://common/rightButtonAction', (data, responseCallback) => {
                // alert(JSON.stringify(data));
                console.log('sdjy://common/rightButtonAction')
                const url = location.href.split('#')[0];
                var params = {
                    data: {
                        title: that.info.title?that.info.title:'智慧园区',
                        detail: that.info.descript?that.info.descript:'智慧园区',
                        url: url,
                        platFormType:'',
                        image: that.$publicData.domain + that.info.thumb
                    },
                };
                this.$bridge.callhandler('sdjy://public/share', params, (data) => {

                })

            })
        } else {
            this.token = this.$store.getters.token;
        }
		// 获取详情
		this.getData()
        // 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
        // this.getShareData()
    },
	mounted() {
		// this.initMap()
	},
    methods: {
		// 获取详情
		getData(){
			var that = this
			var params = {
				venue_id: that.venue_id
			}
			that.$api.smartpark.venuedetail(params).then(res=>{
				if(res.code == 200){
					// 处理富文本
					let info = res.result;
					info.content = info.content.replace(/(<img [^>]*src=['"])([^'"]+)([^>]*)/g,function(match,$1,$2,$3){
						if(/^http/.test($2)){
							return $1 + $2 + $3;
						}else{
							return $1 + that.richImageUrl +$2 + $3;
						}
					})
					that.info = info;
				}
			})
		},
		// 去买门票
		toAppoint(is_tuanti,is_cika){
			var that = this
			if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smart/park/appointticket?is_through_ticket=0&venue_id='+that.venue_id+'&is_tuanti='+is_tuanti+'&is_cika='+is_cika
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
					path: '/smart/park/appointticket',
					query: {
						is_through_ticket: 0 ,
						venue_id: that.venue_id,
						is_tuanti: is_tuanti,
						is_cika: is_cika
					}
				})
            }
			
		},
		// 地图
		initMap(){
			console.log('111111',AMap)
			var that = this
			that.map = new AMap.Map('map', {
				resizeEnable: true, //是否监控地图容器尺寸变化
				zoom: 12, //初始化地图层级
				center: [117.500195, 38.977066] //初始化地图中心点 (津南区)
			});
			// 添加一个景点
			AMap.Marker({
				map: that.map,
				icon: that.publicPath + 'statics/images/map_search_icon.png',
				position: [117.500195, 38.977066] // (该景点)
			})
		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: that.info.title?that.info.title:'智慧园区', // 分享标题
                    desc: that.info.descript?that.info.descript:'智慧园区', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.imageUrl + that.info.thumb, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
